import { Route, Routes } from "react-router-dom";
import DiagnosisResultSetting from "pages/management/setting/diagnosis-result/diagnosis-result";
import DiagnosisResultViewSetting from "pages/management/setting/diagnosis-result/diagnosis-result-view";
import RouteAccessError from "pages/RouteAccessError";
import { PERMISSIONS } from "config/permissions";
import PermissionRoute from "components/route/PermissionRoute";

export default function MonitoringSettingDiagnosisResultRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_IOT_READ}
                        >
                            <DiagnosisResultSetting />
                        </PermissionRoute>
                    }
                />
                <Route path=":id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_IOT_READ}
                        >
                            <DiagnosisResultViewSetting />
                        </PermissionRoute> 
                    }
                 />
                <Route path="*" element={ <RouteAccessError/> }/>
            </Route>
        </Routes>
    );
}